var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about",staticStyle:{"height":"800px"}},[(_vm.jsPlumbReloadData.name)?_c('flow-panel',{attrs:{"menuList":_vm.menuList,"jsPlumbReloadData":_vm.jsPlumbReloadData},on:{"saveRouteLayout":_vm.saveRouteLayout}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }